import api from './api'

export const condicionSaludService = {
  // Listar condiciones de salud (catálogo)
  async getAll(params = {}) {
    const response = await api.get('/condiciones-salud', { params })
    return response.data
  },

  // Obtener condición específica
  async getById(id) {
    const response = await api.get(`/condiciones-salud/${id}`)
    return response.data
  },

  // Crear condición de salud (solo ADMIN/SUPERADMIN)
  async create(data) {
    const response = await api.post('/condiciones-salud', data)
    return response.data
  },

  // Actualizar condición de salud (solo ADMIN/SUPERADMIN)
  async update(id, data) {
    const response = await api.put(`/condiciones-salud/${id}`, data)
    return response.data
  },

  // Eliminar condición de salud (solo ADMIN/SUPERADMIN)
  async delete(id) {
    const response = await api.delete(`/condiciones-salud/${id}`)
    return response.data
  },
}

